import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export default function Vero() {
    const apiAsset = (path) => `${process.env.REACT_APP_API_URL}${path.replace(/^\/+/, '')}`;

    useEffect(() => {
        new Splide('.js-splide-masthead', {
            type: 'fade',
            drag: 'free',
            focus: 'right',
            perPage: 1,
            autoScroll: {
                speed: 1,
            },
            speed: 4e3,
            rewind: !0,
            updateOnMove: !0,
            autoplay: !0,
            interval: 6e3,
            pauseOnHover: !1,
            pauseOnFocus: !1,
            arrows: !1,
            pagination: !1
        }).mount();
    }, []);

    const [BookFromData, setBookFromData] = useState({
        action: 'DemonstrationSubmit',
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: ''
    });

    const [BookFromErrors, setBookFromErrors] = useState({
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: ''
    });

    const [catalouge, setCatalouge] = useState(''); // ✅ यहां पहले से डिक्लेयर है

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Clear error when user starts typing
        if (BookFromErrors[name]) {
            setBookFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateBookForm = () => {
        const errors = {};
        let isValid = true;

        if (!BookFromData.inputFullName.trim()) {
            errors.inputFullName = 'Full Name is required';
            isValid = false;
        }

        if (!BookFromData.inputNumber.trim()) {
            errors.inputNumber = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(BookFromData.inputNumber.replace(/\D/g, ''))) {
            errors.inputNumber = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!BookFromData.inputEmail.trim()) {
            errors.inputEmail = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BookFromData.inputEmail)) {
            errors.inputEmail = 'Please enter a valid email address';
            isValid = false;
        }

        if (!BookFromData.inputCity.trim()) {
            errors.inputCity = 'City is required';
            isValid = false;
        }

        setBookFromErrors(errors);
        return isValid;
    };

    const toastId = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const BookhandleSubmit = async (e) => {
        e.preventDefault();

        if (!validateBookForm()) {           
            return false;
        }

        setIsSubmitting(true);
        toastId.current = toast.loading("Please Wait...");

        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, BookFromData);

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setModalVisible(false);
                setBookFromData({
                    action: 'DemonstrationSubmit',
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: ''
                });
                setBookFromErrors({
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: ''
                });
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const [DownloadFromData, setDownloadFromData] = useState({
        action: 'DownloadBrochureSubmit',
        inputFullName1: '',
        inputNumber1: '',
        inputEmail1: '',
        companyName1: '',
        inputMessage1: '',
        brochure: ''
    });

    const [DownloadFromErrors, setDownloadFromErrors] = useState({
        inputFullName1: '',
        inputNumber1: '',
        inputEmail1: '',
        brochure: ''
    });
    const [isDownloadSubmitting, setIsDownloadSubmitting] = useState(false);

    const DownloadhandleChange = (e) => {
        const { name, value } = e.target;
        setDownloadFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (DownloadFromErrors[name]) {
            setDownloadFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateDownloadForm = () => {
        const errors = {};
        let isValid = true;

        if (!DownloadFromData.inputFullName1.trim()) {
            errors.inputFullName1 = 'Full Name is required';
            isValid = false;
        }

        if (!DownloadFromData.inputNumber1.trim()) {
            errors.inputNumber1 = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(DownloadFromData.inputNumber1.replace(/\D/g, ''))) {
            errors.inputNumber1 = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!DownloadFromData.inputEmail1.trim()) {
            errors.inputEmail1 = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(DownloadFromData.inputEmail1)) {
            errors.inputEmail1 = 'Please enter a valid email address';
            isValid = false;
        }
        if (!DownloadFromData.companyName1.trim()) {
            errors.companyName1 = 'Company Name is required';
            isValid = false;
        }

        if (!DownloadFromData.brochure) {
            errors.brochure = 'Please select a brochure';
            isValid = false;
        }
        if (!DownloadFromData.inputMessage1.trim()) {
            errors.inputMessage1 = 'City Name is required';
            isValid = false;
        }

        setDownloadFromErrors(errors);
        return isValid;
    };

    const DownloadhandleSubmit = async (e) => {
        e.preventDefault();

        if (!validateDownloadForm()) {
            return false;
        }

        setIsDownloadSubmitting(true);
        toastId.current = toast.loading("Please Wait...");

        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, DownloadFromData);

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setModalVisible(false);
                setDownloadFromData({
                    action: 'DownloadBrochureSubmit',
                    inputFullName1: '',
                    inputNumber1: '',
                    inputEmail1: '',
                    companyName1: '',
                    inputMessage1: '',
                    brochure: ''
                });
                setDownloadFromErrors({
                    inputFullName1: '',
                    inputNumber1: '',
                    inputEmail1: '',
                    brochure: ''
                });
                window.open(`${process.env.REACT_APP_APP_URL}/catalouge/assets/catalouge/${DownloadFromData.brochure}`, "_blank");
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsDownloadSubmitting(false);
        }
    };
    
    // ✅ यहां catalouge स्टेट को दोबारा डिक्लेयर नहीं किया गया है
    const ListCatalogueData = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, { action: 'ListCatalogue' });
            setCatalouge(response.data);
        } catch (error) {
            console.error('Error fetching Catalouge data:', error);
        }
    };

    const renderCatalouge = () => {
        if (!catalouge || !catalouge.data) return null;

        return catalouge.data.map(product => (
            <option value={product.pdf}>{product.name}</option>
        ));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const searchQuery = formData.get('search');
        navigate(`/products/search/${encodeURIComponent(searchQuery)}`);
    };

    const navigate = useNavigate();

    useEffect(() => {
        ListCatalogueData();
    }, []);

    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);

    const OpenTingleModal = (modeltype) => {
        if (modeltype) {
            setModalVisible(true);
            setModalType(modeltype);
        } else {
            setModalVisible(false);
        }
    }

    return (
        <>
            <ToastContainer />
        

           <section className="js-block-masthead section section--masthead advanced">
  <div className="section--masthead__top">

    {/* Background Layers */}
    <div
      className="js-parallax images images--middle"
      data-offset="-0.05"
      style={{ backgroundImage: 'url("assets/uploads/bckgnd--masthead-top-01.jpg")' }}
    ></div>

    <div
      className="js-parallax images images--back"
      data-offset="0.15"
      style={{ backgroundImage: 'url("assets/uploads/img--masthead-bckgnd-01.jpg")' }}
    ></div>

    {/* Slider */}
    <div
      className="js-splide-masthead js-parallax images images--front splide splide--masthead"
      data-offset="0.15"
      id="secondary-slider"
    >
      <div className="splide__track">
        <div className="splide__list">
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/vero/slider2.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/vero/slider4.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/vero/slider3.png")' }}></div>
          {/* <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/sveba.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/josper.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/celfrost.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/icetro.png")' }}></div> */}
        </div>
      </div>
    </div>

    {/* Top Content */}
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div >
              <img 
             src={`${process.env.PUBLIC_URL}/assets/uploads/vero/verologo.png`}
              alt="About VERO"
              title="About VERO" style={{ height: '50px', marginBottom: '10px' }} />
            </div>
            <div className="wysiwyg">
              <p>
                VERO is a professional coffee machine brand developed by
              <strong> Middleby Celfrost Innovations Pvt Ltd</strong>, created to
              meet the evolving needs of cafés, offices, bakeries, QSRs, and
              hospitality businesses across India.
              </p>
            </div>

            <div className="row g-2 mt-5">
              <div className="col-md-4">
                <Link className="btn btn--block" to="/our-products">
                  <span>Our Product</span>
                  <span className="icon"></span>
                </Link>
              </div>

              <div className="col-md-8">
                <form
                  className="js-form-product-search"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                  method="GET"
                >
                  <label className="visually-hidden" htmlFor="s">
                    Search products
                  </label>
                  <div className="input-group">
                    <span className="icon">
                      <i className="fas fa-magnifying-glass"></i>
                    </span>
                    <input
                      className="form-control"
                      name="search"
                      type="text"
                      placeholder="Search products…"
                    />
                  </div>
                  <button className="visually-hidden" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  {/* ================= BOTTOM CONTENT (UPDATED FOR VERO) ================= */}
  <div className="section--masthead__bottom">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">

          <div className="wysiwyg text-center">

            <h2 className="primarycolor fw-bold mb-2">
              VERO Professional Coffee Machines
            </h2>

            <p className="fw-semibold mb-3">
              Engineered in Spain. Backed by Middleby Celfrost India.
            </p>

            {/* <p className="mb-3">
              VERO is a professional coffee machine brand developed by
              <strong> Middleby Celfrost Innovations Pvt Ltd</strong>, created to
              meet the evolving needs of cafés, offices, bakeries, QSRs, and
              hospitality businesses across India.
            </p> */}

            <p className="mb-3">
              Designed with European engineering precision and adapted for
              Indian operating conditions, VERO delivers reliable performance,
              consistent coffee quality, and long-term value—supported by
              Middleby Celfrost’s nationwide service and support network.
            </p>

            <p className="fw-semibold mb-4">
              Engineered & Manufactured in Spain <br />
              Designed for Indian businesses
            </p>

            <p>
              <Link
                className="btn mx-2"
                to="/products/brand/vero"
                // onClick={() => OpenTingleModal("freedemo")}
              >
                Explore VERO Machines
                <span className="icon"></span>
              </Link>

              <a
                className="btn btn--secondary mx-2"
                onClick={() => OpenTingleModal("freedemo")}
              >
                Request a Demo
                <span className="icon"></span>
              </a>
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</section>

            
            <div className="section section--shadow top"></div>
            <section className="js-block-masthead section section--masthead advanced">
  <div
    className="section--masthead__bottom fadeinsec mt-3"
    id="next"
    style={{ marginTop: "-30px" }}
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        
        {/* LEFT IMAGE */}
        <div className="col-md-6 col-sm-12 mb-4 mb-md-0">
          <div className="wysiwyg text-center">
            <img
              className="w-100 box-shadow p-3 rounded-1 shadow automaticon  border border-primary exp-img2"
              src={`${process.env.PUBLIC_URL}/assets/uploads/vero/img4.webp`}
              alt="About VERO"
              title="About VERO"
            />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="col-md-6 col-sm-12">
          <div className="wysiwyg">
            
            <h2 className="mb-3 primarycolor fw-bold">
              About VERO
            </h2>

            <p className="mb-3">
              <strong>VERO</strong> was conceived with a clear objective:
              to offer professionally built, dependable coffee machines for businesses seeking consistent coffee quality without the complexity or cost of ultra-premium systems.
            </p>

            <p className="mb-3">
              Developed and marketed by <strong className="primarycolor">Middleby Celfrost India</strong>, VERO focuses on entry to mid-range commercial coffee equipment, combining European manufacturing standards with practical features suited to Indian cafés and commercial environments.
            </p>

            <p className="mb-2 fw-semibold">
              Every VERO machine is built to support:
            </p>

            <ul className="ps-3 mb-3">
              <li>Daily commercial usage</li>
              <li>Consistent extraction and temperature stability</li>
              <li>Ease of operation and maintenance</li>
              <li>Long-term serviceability</li>
            </ul>

            <p className="mb-0">
              <strong>VERO is not about hype.</strong> It is about reliability,
              performance, and confidence in every cup.
            </p>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<section
  className="space-top space-extra-bottom background-image py-5"
  style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-bg-1-1.png')}")` }}
>
  <div className="container">

    {/* SECTION TITLE */}
    <div className="row justify-content-center text-center mb-5">
      <div className="col-lg-8 col-xl-6">
        <div className="title-area">
          <h1 className="sec-subtitle primarycolor fontsizelrg">
            Why Choose VERO
          </h1>
          <p className="mt-3">
            Designed for reliability, consistency, and Indian operations.
          </p>
        </div>
      </div>
    </div>

    {/* FEATURES */}
    <div className="row mt-4 align-items-stretch">

      {/* 1 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-industry"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            European Engineering
          </h3>
          <p className="service-text">
            VERO coffee machines are engineered and manufactured in Spain,
            ensuring high build quality, precision components, and proven
            manufacturing standards.
          </p>
        </div>
      </div>

      {/* 2 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-bolt"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            Built for Indian Operations
          </h3>
          <p className="service-text">
            Designed to perform reliably under Indian conditions—power
            fluctuations, water quality challenges, and high daily usage.
          </p>
        </div>
      </div>

      {/* 3 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-mug-hot"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            Consistent Coffee Quality
          </h3>
          <p className="service-text">
            Stable brewing parameters and dependable extraction ensure
            shot-to-shot consistency, even during peak service hours.
          </p>
        </div>
      </div>

      {/* 4 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-sliders"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            Easy to Operate & Maintain
          </h3>
          <p className="service-text">
            Intuitive operation, simplified maintenance, and practical design
            make VERO ideal for growing businesses.
          </p>
        </div>
      </div>

      {/* 5 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-tools"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            Backed by Middleby Celfrost
          </h3>
          <p className="service-text">
            Installation, training, preventive maintenance, and genuine spares
            supported by Middleby Celfrost’s nationwide service network.
          </p>
        </div>
      </div>

      {/* 6 */}
      <div className="col-md-4 col-lg-4 mb-4 d-flex">
        <div className="service-style1 text-center flex-fill">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>
          <div className="service-icon mx-auto fs-3">
            <i className="fas fa-briefcase"></i>
          </div>
          <h3 className="service-title h5 padding fonttitle">
            Ideal for Entry & Mid-Scale Businesses
          </h3>
          <p className="service-text">
            A smart balance of performance, durability, and value—without
            unnecessary complexity.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>



<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-100 p-0">
    <div className="row g-0">

      {/* LEFT CONTENT */}
      <div className="col-lg-6 section28 d-flex align-items-center">
        <div className="px-3 px-lg-5 py-5">

          <h3 className="primarycolor h1 fw-bold mb-3">
            VERO Coffee Machine Range
          </h3>

          <p className="fs-1-2 mb-4">
            VERO offers a growing range of professional coffee machines designed
            to meet the needs of different business environments—delivering
            dependable performance, consistency, and ease of use.
          </p>

          <h5 className="fw-semibold mb-3">
            Ideal For
          </h5>

          <ul className="list-unstyled mb-4">
            <li className="mb-2">• Independent cafés</li>
            <li className="mb-2">• Corporate offices</li>
            <li className="mb-2">• Bakeries & patisseries</li>
            <li className="mb-2">• QSRs and casual dining</li>
            <li className="mb-2">• Hotels & hospitality spaces</li>
          </ul>

          <h5 className="fw-semibold mb-3">
            Each VERO model is designed to deliver
          </h5>

          <ul className="list-unstyled m-0">
            <li className="mb-2">• Reliable espresso extraction</li>
            <li className="mb-2">• Consistent temperature control</li>
            <li className="mb-2">• Smooth milk texturing capability</li>
            <li className="mb-2">• Ease of use for operators</li>
          </ul>

        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/vero/img10.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "420px",
        }}
      ></div>

    </div>
  </div>
</section>


<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-100 p-0">
    <div className="row g-0">

      {/* LEFT IMAGE */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/vero/img9.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "420px",
        }}
      ></div>

      {/* RIGHT CONTENT */}
      <div className="col-lg-6 section28 d-flex align-items-center">
        <div className="px-3 px-lg-5 py-5">

          <h3 className="primarycolor h1 fw-bold mb-3">
            Coffee Experience That Delivers Confidence
          </h3>

          <p className="fs-1-2 mb-4">
            Great coffee starts with consistency. VERO machines are designed
            to perform reliably in commercial environments, helping teams
            deliver exceptional coffee with confidence.
          </p>

          <h5 className="fw-semibold mb-3">
            VERO machines are built to support:
          </h5>

          <ul className="list-unstyled">
            <li className="mb-2">
              <span className="primarycolor fw-bold">✔</span> Stable brewing temperatures
            </li>
            <li className="mb-2">
              <span className="primarycolor fw-bold">✔</span> Controlled pressure profiles
            </li>
            <li className="mb-2">
              <span className="primarycolor fw-bold">✔</span> Reliable milk steaming performance
            </li>
            <li className="mb-2">
              <span className="primarycolor fw-bold">✔</span> Smooth workflow during busy service hours
            </li>
          </ul>

          <p className="pt-3 mb-0">
            Whether you are serving classic espresso beverages or milk-based
            drinks, <strong>VERO</strong> helps your team deliver consistent
            results — cup after cup.
          </p>

        </div>
      </div>

    </div>
  </div>
</section>


<section
  className="space-top space-extra-bottom background-image py-5"
  style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-bg-1-1.png')}")` }}
>
  <div className="container">

    {/* SECTION TITLE */}
    <div className="row justify-content-center text-center mb-5">
      <div className="col-lg-8 col-xl-6">
        <div className="title-area">
          <h1 className="sec-subtitle primarycolor fontsizelrg">
            Service & Support You Can Reply On
          </h1>
          <p className="mt-3">
            In India, service matters as much as the machine.
          </p>
        </div>
      </div>
    </div>

    {/* SERVICE BOXES */}
    <div className="row mt-4">

      {/* INSTALLATION */}
      <div className="col-md-4 col-lg-4 mb-4">
        <div className="service-style1 text-center">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>

          <div className="service-icon mx-auto">
            <img
              src={apiAsset('assets/img/installation.png')}
              alt="Installation"
            />
          </div>

          <h3 className="service-title h5 padding fonttitle">
            Professional Installation
          </h3>

          <p className="service-text">
            Expert installation and commissioning by trained Middleby Celfrost
            technicians to ensure optimal machine performance from day one.
          </p>
        </div>
      </div>

      {/* TRAINING */}
      <div className="col-md-4 col-lg-4 mb-4">
        <div className="service-style1 text-center">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>

          <div className="service-icon mx-auto">
            <img
              src={apiAsset('assets/img/easytoreach.png')}
              alt="Training"
            />
          </div>

          <h3 className="service-title h5 padding fonttitle">
            Operator Training
          </h3>

          <p className="service-text">
            Hands-on operator training to ensure correct usage, consistent
            coffee quality, and efficient daily operation.
          </p>
        </div>
      </div>

      {/* PREVENTIVE MAINTENANCE */}
      <div className="col-md-4 col-lg-4 mb-4">
        <div className="service-style1 text-center">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>

          <div className="service-icon mx-auto">
            <img
              src={apiAsset('assets/img/maintaince.png')}
              alt="Maintenance"
            />
          </div>

          <h3 className="service-title h5 padding fonttitle">
            Preventive Maintenance
          </h3>

          <p className="service-text">
            Scheduled preventive maintenance programs designed to reduce
            downtime and extend machine life.
          </p>
        </div>
      </div>

      {/* SPARES */}
      <div className="col-md-4 col-lg-4 mb-4">
        <div className="service-style1 text-center">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>

          <div className="service-icon mx-auto">
            <img
              src={apiAsset('assets/img/breakdownservice.png')}
              alt="Spare Parts"
            />
          </div>

          <h3 className="service-title h5 padding fonttitle">
            Genuine Spare Parts
          </h3>

          <p className="service-text">
            Easy availability of genuine spare parts to maintain performance,
            safety, and long-term reliability.
          </p>
        </div>
      </div>

      {/* NATIONWIDE SERVICE */}
      <div className="col-md-4 col-lg-4 mb-4">
        <div className="service-style1 text-center">
          <div
            className="service-bg background-image"
            style={{ backgroundImage: `url("${apiAsset('assets/img/bg/sr-box-bg-1.jpg')}")` }}
          ></div>

          <div className="service-icon mx-auto">
            <img
              src={apiAsset('assets/img/presence.png')}
              alt="Service Network"
            />
          </div>

          <h3 className="service-title h5 padding fonttitle">
            Nationwide Service Reach
          </h3>

          <p className="service-text">
            Supported by Middleby Celfrost’s extensive service network across
            India—wherever your business operates.
          </p>
        </div>
      </div>

    </div>

    {/* FOOT NOTE */}
    <div className="row justify-content-center text-center ">
      <div className="col-lg-8">
        <p className="">
          This means peace of mind, reduced downtime, and long-term operational
          reliability with every VERO machine.
        </p>
      </div>
    </div>

  </div>
</section>

<section className={`section p-0 section1 bg-dark section--products m-0`}>
  <div className="w-98 p-0">
    <div className="row align-items-center">

      {/* LEFT CONTENT */}
      <div className="col-lg-6 section28">
        <div className="px-4 py-5">

          <h3 className="primarycolor h1 fw-bold mb-4">
            Growing Into Complete Coffee Solutions
          </h3>

          <p className="text-dark fs-5 mb-3">
            VERO is a developing coffee solutions brand.
          </p>

          <p className="text-dark fs-5 mb-4">
            In addition to coffee machines, the VERO portfolio will expand to include:
          </p>

          <ul className="list-unstyled text-dark fs-5 mb-4">
            <li className="mb-2">✔ Professional coffee grinders</li>
            <li className="mb-2">✔ Accessories and complementary equipment</li>
          </ul>

          <p className="text-dark fs-5 lh-base">
            Our goal is to offer complete, practical coffee solutions for Indian businesses —
            <span className="fw-bold"> backed by trusted service and long-term commitment.</span>
          </p>

        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div
        className="col-lg-6 p-0 aboutvisionimage"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/vero/img2.webp)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "388px"
        }}
      ></div>

    </div>
  </div>
</section>

<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-98 p-0">
    <div className="row">

      {/* Left Image */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/vero/img6.webp)`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      ></div>

      {/* Right Content */}
      <div className="col-lg-6 section28">
        <div className="px-3 mt-4 mb-2 pb-2">

          <h3 className="primarycolor h1 fw-bold">
            Who Is VERO For
          </h3>

          <p className="mt-3 fs-1-2 lh-base">
            VERO is designed for businesses that want:
          </p>

          <ul className="list-unstyled mt-3 fs-1-2 lh-lg">
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Professional-grade coffee equipment
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Consistent quality without overcomplexity
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Reliable service support
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              A brand backed by a trusted Indian organization
            </li>
          </ul>

          <p className="pt-3 fw-semibold fs-1-2">
            If you are building or scaling your coffee offering,
            <span className="primarycolor"> VERO </span>
            is built for you.
          </p>

        </div>
      </div>

    </div>
  </div>
</section>

<section className="section bg-white section--products">
  <div className="container">

    {/* Heading */}
    <div className="text-center mb-4">
      <h2 className="primarycolor fw-bold">
        Talk to Our Coffee Solutions Expert
      </h2>
    </div>

    {/* Paragraphs */}
    <div className="text-center mb-4">
      <p className="fs-1-2 lh-base mb-2">
        Looking for the right coffee machine for your business?
      </p>
      <p className="fs-1-2 lh-base">
        Our team can help you select the most suitable VERO solution based on:
      </p>
    </div>

    {/* Points Row */}
    <div className="row text-center">

      <div className="col-lg-3 col-md-6 mb-3">
        <div className="p-3 shadow-sm rounded h-100">
          <i className="fas fa-store fs-2 text-primary mb-2"></i>
          <p className="fw-semibold mb-0">
            Your Business Type
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mb-3">
        <div className="p-3 shadow-sm rounded h-100">
          <i className="fas fa-chart-line fs-2 text-primary mb-2"></i>
          <p className="fw-semibold mb-0">
            Expected Daily Volume
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mb-3">
        <div className="p-3 shadow-sm rounded h-100">
          <i className="fas fa-mug-hot fs-2 text-primary mb-2"></i>
          <p className="fw-semibold mb-0">
            Menu Requirements
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mb-3">
        <div className="p-3 shadow-sm rounded h-100">
          <i className="fas fa-wallet fs-2 text-primary mb-2"></i>
          <p className="fw-semibold mb-0">
            Budget & Future Growth
          </p>
        </div>
      </div>

    </div>

  </div>
</section>




            <div className={`tingle-modal tingle-modal--overflow ${modalVisible ? 'tingle-modal--visible' : ''}`} id="tingle-modal23">
                <button type="button" className="tingle-modal__close" id="tingle-modal__close23" onClick={() => OpenTingleModal()}>
                    <span className="tingle-modal__closeIcon">
                    </span>
                    <span className="tingle-modal__closeLabel">Close</span>
                </button>
                <div className="tingle-modal-box">
                    <div className="tingle-modal-box__content">
                        {modalType && modalType === 'freedemo' &&
                            <div id="demonstration1" className="modal-content">
                                <div className="wysiwyg">
                                    <h2>
                                        <strong>Book a Demonstration</strong>
                                    </h2>
                                </div>
                                <div className="wpcf7 js" id="wpcf7-f698-o1" lang="en-GB" dir="ltr">
                                    <div className="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form onSubmit={BookhandleSubmit} method="post" id="add_Form" className="wpcf7-form init">
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${BookFromErrors.inputFullName ? 'error' : ''}`}
                                                    name="inputFullName"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputFullName}
                                                    type="text"
                                                    id="inputFullName"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputFullName">Full Name*</label>
                                                {BookFromErrors.inputFullName && <span className="error-message">{BookFromErrors.inputFullName}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${BookFromErrors.inputNumber ? 'error' : ''}`}
                                                    name="inputNumber"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputNumber}
                                                    type="tel"
                                                    id="inputNumber"
                                                    placeholder=" "
                                                    maxLength={10}
                                                />
                                                <label className="label" htmlFor="inputNumber">Contact Number*</label>
                                                {BookFromErrors.inputNumber && <span className="error-message">{BookFromErrors.inputNumber}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${BookFromErrors.inputEmail ? 'error' : ''}`}
                                                    name="inputEmail"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputEmail}
                                                    type="email"
                                                    id="inputEmail"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputEmail">Email Address*</label>
                                                {BookFromErrors.inputEmail && <span className="error-message">{BookFromErrors.inputEmail}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text ${BookFromErrors.inputCity ? 'error' : ''}`}
                                                    name="inputCity"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputCity}
                                                    type="text"
                                                    id="inputCity"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputCity">City*</label>
                                                {BookFromErrors.inputCity && <span className="error-message">{BookFromErrors.inputCity}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-group-textarea form-label-field">
                                            <p>
                                                <textarea
                                                    onChange={handleChange}
                                                    cols="40"
                                                    rows="10"
                                                    className="wpcf7-form-control wpcf7-textarea"
                                                    name="inputMessage"
                                                    aria-invalid="false"
                                                    id="inputMessage"
                                                    value={BookFromData.inputMessage}
                                                    placeholder=" "
                                                ></textarea>
                                                <label className="label" htmlFor="inputMessage">How can we help?</label>
                                            </p>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <p>*Required </p>
                                            </div>
                                            <div className="col-5">
                                                <p>
                                                    <button
                                                        className="btn btn--secondary btn--block"
                                                        name="DemonstrationSubmit"
                                                        id="DemonstrationSubmit"
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                    >
                                                        <span>{isSubmitting ? "Please Wait..." : "Send"}</span>
                                                        <span className="icon"></span>
                                                    </button>

                                                </p>
                                            </div>
                                        </div>
                                        <div className="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        }

                        {modalType && modalType === 'downloadbroucher' &&
                            <div id="demonstration2" className="modal-content">
                                <div className="wysiwyg">
                                    <h2>
                                        <strong>Download your 2024 brochure</strong>
                                    </h2>
                                </div>
                                <div className="wpcf7 js" id="wpcf7-f698-o2" lang="en-GB" dir="ltr">
                                    <div className="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form onSubmit={DownloadhandleSubmit} method="post" id="add_Form2" className="wpcf7-form init" aria-label="Contact form" noValidate="novalidate" data-status="init">
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={DownloadhandleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${DownloadFromErrors.inputFullName1 ? 'error' : ''}`}
                                                    name="inputFullName1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputFullName1}
                                                    type="text"
                                                    id="inputFullName1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputFullName1">Full Name*</label>
                                                {DownloadFromErrors.inputFullName1 && <span className="error-message">{DownloadFromErrors.inputFullName1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${DownloadFromErrors.inputNumber1 ? 'error' : ''}`}
                                                    name="inputNumber1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputNumber1}
                                                    type="tel"
                                                    id="inputNumber1"
                                                    placeholder=" "
                                                    maxLength={10}
                                                />
                                                <label className="label" htmlFor="inputNumber1">Contact Number*</label>
                                                {DownloadFromErrors.inputNumber1 && <span className="error-message">{DownloadFromErrors.inputNumber1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${DownloadFromErrors.inputEmail1 ? 'error' : ''}`}
                                                    name="inputEmail1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputEmail1}
                                                    type="email"
                                                    id="inputEmail1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputEmail1">Email Address*</label>
                                                {DownloadFromErrors.inputEmail1 && <span className="error-message">{DownloadFromErrors.inputEmail1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className="wpcf7-form-control wpcf7-text"
                                                    name="companyName1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.companyName1}
                                                    type="text"
                                                    id="companyName1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="companyName1">Company Name</label>
                                                {DownloadFromErrors.companyName1 && <span className="error-message">{DownloadFromErrors.companyName1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <select
                                                    id="brochure"
                                                    name="brochure"
                                                    onChange={DownloadhandleChange}
                                                    className={`wpcf7-form-control ${DownloadFromErrors.brochure ? 'error' : ''}`}
                                                    value={DownloadFromData.brochure}
                                                >
                                                    <option value="">Select Brochure*</option>
                                                    {renderCatalouge()}
                                                </select>
                                                <label className="label" htmlFor="brochure">Brochure*</label>
                                                {DownloadFromErrors.brochure && <span className="error-message">{DownloadFromErrors.brochure}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-group-textarea form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    className="wpcf7-form-control wpcf7-text"
                                                    name="inputMessage1"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputMessage1}
                                                    id="inputMessage1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputMessage1">City</label>
                                                {DownloadFromErrors.inputMessage1 && <span className="error-message">{DownloadFromErrors.inputMessage1}</span>}
                                            </p>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <p>*Required </p>
                                            </div>
                                            <div className="col-5">
                                                <p>
                                                    <button
                                                        className="btn btn--secondary btn--block"
                                                        id="DownloadBrochureSubmit"
                                                        name="DownloadBrochureSubmit"
                                                        type="submit"
                                                        disabled={isDownloadSubmitting}
                                                    >
                                                        <span>{isDownloadSubmitting ? "Please Wait..." : "Download"}</span>
                                                        <span className="icon"></span>
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
